import { render, staticRenderFns } from "./VxBackButton.vue?vue&type=template&id=0c278fbe"
import script from "./VxBackButton.vue?vue&type=script&lang=js"
export * from "./VxBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports